// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1Vivr","list":"styles_list__RZNWW"};